import { useRef } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';

interface BackupCodesDisplayProps {
  codes: string[];
}

export const BackupCodesDisplay: React.FC<BackupCodesDisplayProps> = ({ codes }) => {
  const toast = useRef<Toast>(null);

  const handleCopy = () => {
    const codesText = codes.join('\n');
    navigator.clipboard.writeText(codesText);
    toast.current?.show({
      severity: 'success',
      summary: 'Copied',
      detail: 'Backup codes copied to clipboard',
      life: 2000,
    });
  };

  const handleDownload = () => {
    const codesText = `Tallai Backup Codes\n${'='.repeat(20)}\n\n${codes.join('\n')}\n\nKeep these codes safe. Each code can only be used once.`;
    const blob = new Blob([codesText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'tallai-backup-codes.txt';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <Toast ref={toast} />

      <Message
        severity="warn"
        text="Save these backup codes in a safe place. Each code can only be used once to access your account if you lose your device."
      />

      <div className="backup-codes-actions">
        <Button
          label="Copy All"
          icon="ms-out ms-out-content-copy"
          size="small"
          text
          onClick={handleCopy}
        />
        <Button
          label="Download"
          icon="ms-out ms-out-download"
          size="small"
          text
          onClick={handleDownload}
        />
      </div>

      <div className="two-factor-backup-codes">
        {codes.map((code, index) => (
          <div key={index} className="two-factor-backup-code">
            <code>{code}</code>
          </div>
        ))}
      </div>
    </>
  );
};

export default BackupCodesDisplay;
